import { useNavigate } from "react-router-dom";
import { useIs17Inch } from "../../../hooks/useBreakPoint";

import { WelcomeImg } from "../../../images/icons/icons_component";

const JoinStep4 = () => {
    const navigate = useNavigate();

    const handleNext = async () => {
        try {
            navigate("/member/login.do");
        } catch (e) {
            console.error('오류 발생', e);
        }
    };

    const is17Inch = useIs17Inch();

    return (
        <div className='join_contents'>
            <div className='flex flex-col gap-5'>
                <hr/>
                <div className={`content_section w-full ${is17Inch ? 'p-6' : 'py-14'}`}>
                    <WelcomeImg/>
                    <h3>회원가입이 완료되었습니다.</h3>
                    <h5 className='co_gray'>원활한 사용을 위한 회원 정보 업데이트를 위해 1분 뒤 로그인 해 주시기 바랍니다.</h5>
                </div>
                <hr/>
            </div>
            <div className='comm_btn_box h-12'>
                <button className='comm_btn bg_co_black w-40' onClick={handleNext} id='btnNext' title='로그인'>로그인</button>
            </div>
        </div>
    )
}

export default JoinStep4;